import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Form, Button } from 'react-bootstrap';
import CompLoginModal from "./CompLoginModal";
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';

function CompNavbar(props) {
  const [modalShow, setModalShow] = React.useState(false);

  const user = false;
  return (
    <Navbar bg="light" expand="lg" fixed="top">
      <Navbar.Brand>
        <Link to="/">Logo Produto</Link>
      </Navbar.Brand>
      <Nav className="mr-auto">
      </Nav>
      <Form inline>
        {!user ?
          <Button variant="outline-secondary" onClick={() => setModalShow(true)}>{trad(props.trads, 'ENTRAR', props.language)}</Button>
          :
          <NavDropdown alignRight className="pullRight" title="Fulano" id="basic-nav-dropdown">
            <NavDropdown.Item href="#action/3.1">Dashboard</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.4">{trad(props.trads, 'SAIR', props.language)}</NavDropdown.Item>
          </NavDropdown>
        }
      </Form>
      <CompLoginModal 
        language={props.language}
        show={modalShow}
        onHide={() => setModalShow(false)} />
    </Navbar>
  );
}
const mapStateToProps = (state) => {
  return {
    trads: state.reducerTraducoes
  };
}
export default connect(mapStateToProps)(CompNavbar);



